/** Push an event to the GTM dataLayer, creating it if GTM hasn't loaded yet. */
export const pushToDataLayer = (payload: Record<string, unknown>) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
};
